import { Create, Edit, List } from "../Components/index.js";

export default [
    {
        path: "/admin/appointed",
        component: List,
        name: "admin-appointed-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/appointed/create",
        component: Create,
        name: "admin-appointed-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/appointed/:id/edit",
        component: Edit,
        name: "admin-appointed-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
